<template>
    <router-view />
</template>

<script>
export default {
    name:'Main',
    data(){
        return {
          
        }
    },
    components:{
    }
}
</script>

<style>


</style>